import React from 'react'
import ThinArrowRight from '../../../icons/ThinArrowRight'

const SeeAllButton = ({size=""}) => {
  return (
    <div className={`flex justify-center items-center gap-[3px] see-all-parent ${size === "large" ? "see-all-parent-with-large-icon" : ""}`}>
    <span className='see-all-button'> See all</span>
    <ThinArrowRight css={size==="large"?"large-icon":"small-icon"}/>
    </div>
  )
}

export default SeeAllButton
